<template>
  <ReportPeriodHeatmap
    :title="title"
    :rowData="rowData"
    :periods="periods"
    :pinnedBottom="pinnedBottom"
    :periodicity="periodicity"
    :tooltipComponent="tooltipComponent"
    :valueFormatter="formatCellValue"
    :cellStyle="slaCellStyle"
    :getRowStyle="slaGetRowStyle"
    @cell-click="onCellClick"
  />
</template>

<script>
import ReportPeriodHeatmap from '@/components/Reports/ReportPeriodHeatmap.vue';
import SlaCellTooltip from './SlaCellTooltip.vue';

export default {
  name: 'SlaHeatmap',
  components: { ReportPeriodHeatmap },
  props: {
    title: {
      type: String,
      required: true,
    },
    rowData: {
      type: Array,
      default() {
        return [];
      },
    },
    periods: {
      type: Array,
      default() {
        return [];
      },
    },
    pinnedBottom: {
      type: Array,
      default() {
        return [];
      },
    },
    metric: {
      type: String,
      required: true,
    },
    periodicity: {
      type: String,
      required: true,
    },
    flag: {
      type: String,
      required: true,
    },
  },
  emits: ['cell-open-notes'],
  data() {
    return {
      tooltipComponent: SlaCellTooltip,
    };
  },
  computed: {
    percentMetric() {
      return this.metric !== '# of Units out of SLA';
    },
  },
  methods: {
    formatCellValue(value) {
      if (value === null || value === undefined) return '';
      if (this.percentMetric) return `${Number(value).toFixed(1)}%`;
      return Number(value).toLocaleString('en-US');
    },
    onCellClick({ data, periodKey }) {
      this.$emit('cell-open-notes', {
        flag: this.flag,
        brandName: data.BRAND_NAME,
        periodKey,
      });
    },
    slaGetRowStyle(params) {
      if (params.node.rowPinned) {
        return {
          fontWeight: '400',
          backgroundColor: '#FFFFFF',
          textAlign: 'center',
          color: '#000000',
        };
      }
      return null;
    },
    slaCellStyle(params, periodKey) {
      if (params.node.rowPinned) {
        return {
          backgroundColor: '#F5F5F5',
          fontWeight: '400',
          textAlign: 'center',
        };
      }
      const hasNotes = !!(params.data && params.data[`${periodKey}_hasNotes`]);
      const base = {
        textAlign: 'center',
        cursor: 'pointer',
        boxShadow: hasNotes ? 'inset 0 -2px 0 #545c66' : undefined,
      };
      if (!this.percentMetric) {
        return {
          ...base,
          color: 'black',
          fontWeight: '400',
        };
      }
      const val = parseFloat(params.value);
      if (Number.isNaN(val)) return base;
      if (val >= 99) {
        return {
          ...base,
          backgroundColor: '#03FF00',
          color: 'black',
          fontWeight: '400',
        };
      }
      return {
        ...base,
        backgroundColor: '#FF0000',
        color: 'white',
        fontWeight: '400',
      };
    },
  },
};
</script>
